import * as HttpService from "./http.service";
import { DUMP_LOGS_TO_AWS_CLOUD_WATCH_URL } from "./url.service";

export const dumpLogsToAwsCloudWatch = (body) => {
  return HttpService.postWithOutAuth(DUMP_LOGS_TO_AWS_CLOUD_WATCH_URL, body);
};